import { SET_REFRESH_TOKEN, SET_ACCESS_TOKEN, CLEAR_TOKENS, TOKEN_CHECKED } from './mutation-types'

const EXPIRATION_DELAY = 60 * 1000 * 5
const MIN_INTERVAL = 60 * 1000 * 1

const state = {
  accessToken: null,
  accessExpiresAt: null,
  refreshExpiresAt: null,
  isTokenChecked: false
}

let timeout = null

const mutations = {
  [SET_ACCESS_TOKEN] (state, { accessToken, accessExpiresAt }) {
    state.accessToken = accessToken
    state.accessExpiresAt = accessExpiresAt
  },
  [SET_REFRESH_TOKEN] (state, payload) {
    state.refreshExpiresAt = payload
  },
  [CLEAR_TOKENS] (state) {
    state.accessToken = null
    state.accessExpiresAt = null
    state.refreshExpiresAt = null
  },
  [TOKEN_CHECKED] (state) {
    state.isTokenChecked = true
  }
}

const actions = {
  refreshAccessToken ({ commit, dispatch }) {
    return this.$http.patch('/users/sessions', {})
      .then(res => {
        const { accessToken, accessExpiresAt, refreshExpiresAt } = res.data.token
        localStorage.setItem('accessExpiresAt', accessExpiresAt)
        localStorage.setItem('refreshExpiresAt', refreshExpiresAt)
        commit(SET_ACCESS_TOKEN, { accessToken, accessExpiresAt })
        commit(SET_REFRESH_TOKEN, refreshExpiresAt)
        commit(TOKEN_CHECKED)
        return dispatch('user/handleSessionUpdate', res.data, { root: true })
      })
  },
  startRefreshCountdown ({ dispatch, getters }) {
    const expiration = new Date(getters.accessExpiresAt).getTime()
    const now = new Date().getTime()
    const interval = expiration - now - EXPIRATION_DELAY
    if (interval > MIN_INTERVAL) {
      timeout = setTimeout(() => {
        dispatch('refreshAccessToken')
          .catch(err => {
            dispatch('user/handleRefreshFail', err, { root: true })
          })
      }, interval)
    }
  },
  setTokensData ({ commit, dispatch }, payload) {
    const { accessToken, accessExpiresAt, refreshExpiresAt } = payload
    localStorage.setItem('accessExpiresAt', accessExpiresAt)
    localStorage.setItem('refreshExpiresAt', refreshExpiresAt)
    commit(SET_ACCESS_TOKEN, { accessToken, accessExpiresAt })
    commit(SET_REFRESH_TOKEN, refreshExpiresAt)
    commit(TOKEN_CHECKED)
    dispatch('startRefreshCountdown')
  },
  clearTokens ({ commit }) {
    localStorage.removeItem('accessExpiresAt')
    localStorage.removeItem('refreshExpiresAt')
    clearTimeout(timeout)
    commit(CLEAR_TOKENS)
  },
  setTokenChecked ({ commit }) {
    commit(TOKEN_CHECKED)
  }
}

const getters = {
  accessToken: state => state.accessToken,
  accessExpiresAt: state => state.accessExpiresAt,
  refreshExpiresAt: state => state.refreshExpiresAt,
  isTokenChecked: state => state.isTokenChecked,
  isAccessToken: state => state.isTokenChecked && state.accessToken
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
